import { REPEAT_LABELS } from "../bookkeeping";

// The rotating-arrows "repeats" glyph. Green for recurring work; red with a
// line across it for work that does not repeat.
export function RepeatArrows({ size = 18, color = "#00854d", crossed = false }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      {crossed && <line x1="3" y1="21" x2="21" y2="3" strokeWidth="2.5" />}
    </svg>
  );
}

// Repeats column cell: the icon with Monthly / Quarterly / ... underneath.
export function RepeatsCell({ recurrence }) {
  const none = !recurrence || recurrence === "none";
  const label = REPEAT_LABELS[recurrence] || REPEAT_LABELS.none;
  return (
    <div
      title={none ? "Does not repeat" : `Repeats ${label.toLowerCase()}`}
      data-testid="repeats-cell"
      style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        lineHeight: 1.1, fontSize: 11, color: none ? "#d83a52" : "#323338",
      }}
    >
      <RepeatArrows color={none ? "#d83a52" : "#00854d"} crossed={none} />
      <span style={{ marginTop: 2 }}>{label}</span>
    </div>
  );
}

// Roll forward: an arrow into a bar ("on to the next one").
export function RollForwardIcon({ size = 16, color = "currentColor" }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="13 17 18 12 13 7" />
      <polyline points="6 17 11 12 6 7" />
      <line x1="21" y1="6" x2="21" y2="18" />
    </svg>
  );
}

export function CheckIcon({ size = 18, color = "#00a35c" }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
